/**
 * Validation rules for cohort-tag names, shared between the backend DTOs/service
 * and the frontend so both enforce exactly the same rules:
 *  - at most {@link TAG_NAME_MAX_LENGTH} characters,
 *  - alphanumeric plus space, underscore, hyphen, colon and pipe,
 *  - unique (case-insensitive) within a programme — enforced separately in the
 *    service and by a partial unique index on `(mipId, lower(name))`.
 */

export const TAG_NAME_MAX_LENGTH = 48;

/**
 * Allowed characters in a tag name: letters, digits, spaces, and `_ - : |`.
 * The hyphen is last inside the character class so it is treated as a literal
 * rather than a range.
 */
export const TAG_NAME_ALLOWED_PATTERN = /^[A-Za-z0-9 _:|-]+$/;

export const TAG_NAME_VALIDATION_MESSAGE =
	'Tag name may only contain letters, numbers, spaces and the characters _ - : |';

export const isValidTagName = (name: string): boolean =>
	name.length > 0 && name.length <= TAG_NAME_MAX_LENGTH && TAG_NAME_ALLOWED_PATTERN.test(name);
